








import Vue from "vue";
import { Component } from "vue-property-decorator";
import ApiFactory from "../../api/ApiFactory";
import { PolicyTypeDto } from "@/api/ClientPortalApiClient";

@Component({})
export default class CbxPolicyType extends Vue {
  private types: PolicyTypeDto[] | null = [];
  public selectedType = new PolicyTypeDto();

  public created() {
    this.getAvailableTypes();
  }

  public setSelected(type: PolicyTypeDto | undefined) {
    if (type) {
      this.selectedType = type;
    }
  }

  public setSelectedName(name: string) {
    if (this.types) {
      this.types.forEach(element => {
        if (element.name === name) {
          this.selectedType = element;
          return;
        }
      });
    }
  }

  public typeSelected(type: PolicyTypeDto) {
    this.$emit("policyTypeSelected", type);
  }

  private getAvailableTypes() {
    const api = ApiFactory.CreateDataClient();
    api
      .policyType_IndexAll()
      .then(result => {
        if (result) {
          this.types = result;
        } else {
          this.types = [];
        }
      })
      .catch(error => {
        console.log(error);
        this.types = [];
      });
  }
}
